// extracted by mini-css-extract-plugin
export default {"wrapper":"DataTable_wrapper__c9dkH","tableContainer":"DataTable_tableContainer__+7HNA","table":"DataTable_table__sguJT","paginationWrapper":"DataTable_paginationWrapper__v14tA"};